import React from "react";

interface FocusedKeyboardIconProps {
  className?: string;
  style?: React.CSSProperties;
  focused?: boolean;
}

/**
 * Custom Keyboard icon matching Lucide's design,
 * with selective white fill on the body when focused (light mode only).
 * In dark mode, no fill is applied.
 */
export function FocusedKeyboardIcon({ className, style, focused }: FocusedKeyboardIconProps) {
  const isDarkMode = typeof document !== 'undefined' && document.documentElement.classList.contains('dark');
  const shouldFill = focused && !isDarkMode;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      style={style}
    >
      <rect width="20" height="16" x="2" y="4" rx="2" fill={shouldFill ? "white" : "none"} />
      <path d="M6 8h.001" />
      <path d="M10 8h.001" />
      <path d="M14 8h.001" />
      <path d="M18 8h.001" />
      <path d="M8 12h.001" />
      <path d="M12 12h.001" />
      <path d="M16 12h.001" />
      <path d="M7 16h10" />
    </svg>
  );
}
